import { deDEMessages } from "./locales/de-DE"
import { enUSMessages } from "./locales/en-US"
import { frFRMessages } from "./locales/fr-FR"
import { zhHansMessages } from "./locales/zh-Hans"
import { zhHantMessages } from "./locales/zh-Hant"

export const supportedLocales = [
  "en-US",
  "de-DE",
  "fr-FR",
  "zh-Hans",
  "zh-Hant",
] as const

export type AppLocale = (typeof supportedLocales)[number]

export const defaultLocale: AppLocale = "en-US"

export type MessageId = keyof typeof enUSMessages
export type MessageValues = Record<string, string | number | Date>

export const messagesByLocale: Record<AppLocale, Record<MessageId, string>> = {
  "de-DE": deDEMessages,
  "en-US": enUSMessages,
  "fr-FR": frFRMessages,
  "zh-Hans": zhHansMessages,
  "zh-Hant": zhHantMessages,
}

export { enUSMessages }
